import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

declare var require: any

const SECRET_KEY = '(m2H:)1=G:4`?|w';

@Injectable()

export class StorageService {
    constructor() { }

    encrypt(data) {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);
        data = data.toString();
        return data;
    }

    decrypt(data) {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);
        data = data.toString(CryptoJS.enc.Utf8);
        return data;
    }
}